import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './help-faq-section.scss';

applyTranslations(require('./help-faq-section.i18n.json'));

type Props = {
  url: string
};

const HelpFAQSection = (
  {
    url
  }: Props
): JSX.Element => (
  <div className="help-faq-section">
    <a
      className="help-faq-section__link-block"
      rel="noopener noreferrer"
      target="_blank"
      href={url}
    >
      <span className="help-faq-section__link-text">
        {__t('help_faq_section.label')}
      </span>
    </a>
    <hr className="help-faq-section__separator" />
  </div>
);

export default HelpFAQSection;
